import VaTextareaField from 'platform/forms-system/src/js/web-component-fields/VaTextareaField';
import VaTextInputField from 'platform/forms-system/src/js/web-component-fields/VaTextInputField';
import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';

import FileUpload from '../../../components/FileUpload';
import PageFieldSummary from '../../../components/PageFieldSummary';
import { CategoryEducation } from '../../../constants';
import { allowAttachments } from '../../../utils/helpers';

export const fileSchema = {
  type: 'array',
  items: {
    type: 'object',
    properties: {
      fileName: {
        type: 'string',
      },
      fileSize: {
        type: 'integer',
      },
      fileType: {
        type: 'string',
      },
      base64: {
        type: 'string',
      },
      fileID: {
        type: 'string',
      },
    },
  },
};

const pageTitle = 'Your question';

const yourQuestionPage = {
  uiSchema: {
    ...titleUI(pageTitle),
    'ui:objectViewField': PageFieldSummary,
    subject: {
      'ui:title': 'Subject',
      'ui:webComponentField': VaTextInputField,
      'ui:errorMessages': {
        required: 'Enter a subject for your question.',
        pattern: 'Enter a valid subject.',
      },
      'ui:required': formData =>
        formData.selectCategory === CategoryEducation ||
        formData.selectTopic === CategoryEducation,
      'ui:options': {
        hideIf: formData =>
          !(
            formData.selectCategory === CategoryEducation ||
            formData.selectTopic === CategoryEducation
          ),
      },
    },
    question: {
      'ui:title': "What's your question?",
      'ui:webComponentField': VaTextareaField,
      'ui:required': () => true,
      'ui:errorMessages': {
        required: 'Let us know what your question is about.',
        pattern: 'Enter a valid question.',
      },
      'ui:options': {
        required: true,
        charcount: true,
        useFormsPattern: 'single',
      },
    },
    fileUpload: {
      'ui:title': 'Select optional files to upload',
      'ui:webComponentField': FileUpload,
      'ui:options': {
        hideIf: formData => !allowAttachments(formData),
      },
    },
  },
  schema: {
    type: 'object',
    required: [],
    properties: {
      subject: {
        type: 'string',
        pattern: /\S/, // At least one non-whitespace character
        minLength: 1,
        maxLength: 140,
      },
      question: {
        type: 'string',
        pattern: /\S/, // At least one non-whitespace character
        minLength: 1,
        maxLength: 10000,
      },
      fileUpload: fileSchema,
    },
  },
  title: pageTitle,
};

export default yourQuestionPage;
